import{Characters as e}from"../../item/Characters.mjs";const r={companyCode:e.preset.halfWidth(),companyName:e.preset.freeFormat()};export{r as companyAttributeConfig};
